import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { SyncLoader } from "react-spinners";
import { ReactComponent as RightArrowIcon } from "../../../assets/right-arrow.svg";
import useResponsive from "../../../hooks/useResponsive";
import { usePumpRecommendationContext } from "../../../context/PumpRecommendationContext";
import { useUpdateAlternativeEmailRecord } from "../../../hooks/services";

export const ResultReportBox = ({ onGeneratePdf }: { onGeneratePdf: any }) => {
  const { formData, reportId } = usePumpRecommendationContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState("");
  const [nameModalOpen, setNameModalOpen] = useState("");
  const { isSm, isXs } = useResponsive();
  const isMobile = isSm || isXs;
  const firstInputRef = useRef<HTMLInputElement>(null);

  
  const updateAlternativeEmail = useUpdateAlternativeEmailRecord();

  const handleUserAlternativeEmail = () => {
    setEmailModalOpen("");
    setNameModalOpen("");
    firstInputRef.current?.focus();
  };

  const handleClose = () => {
    setModalIsOpen(false);
  };

  const handleSendEmail = () => {
    const updateData = {
      alternativeEmail:
        emailModalOpen === formData?.email ? formData?.email : emailModalOpen,
      alternativeName: nameModalOpen !== formData?.user ? nameModalOpen : ``,
      email: formData?.email || "",
      reportId: reportId ? reportId : (() => { 
        console.error("❌ Missing reportId. Cannot proceed with email update.");
        throw new Error("Missing reportId");
      })(),
      sendAlternativeEmail: emailModalOpen !== formData?.email ? true : false,
      sendEmail: emailModalOpen !== formData?.email ? false : true,
    };

    updateAlternativeEmail.mutate(updateData, {
      onSuccess: () => {
        setModalIsOpen(false);
      },
      onError: (error) => {
        console.error("❌ Error updating alternative email:", error);
        
      },
    });
  };

  return (
    <Box>
      <Box
        my={isMobile ? 4 : 10}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={isMobile ? "column" : "row"}
        px={isMobile ? 4 : 0}
        gap={2}
      >
        <Button
          variant="contained"
          style={{ justifyContent: "flex-start" }}
          startIcon={<RightArrowIcon />}
          fullWidth={isMobile ? true : false}
          onClick={() => setModalIsOpen(true)}
        >
          <Typography>Email</Typography>
        </Button>
        <Button
          startIcon={<RightArrowIcon />}
          variant="contained"
          onClick={onGeneratePdf}
          style={{
            justifyContent: "flex-start",
            width: isMobile ? "100%" : "fit-content",
          }}
        >
          {updateAlternativeEmail.isPending ? (
            <SyncLoader
              color={"#fff"}
              size={5}
              loading={updateAlternativeEmail.isPending}
            />
          ) : (
            <Typography>Print your results</Typography>
          )}
        </Button>
      </Box>
      <Modal open={modalIsOpen} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            width: 400,
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Typography variant="h6" align="left">
            Name
          </Typography>
          <TextField
            fullWidth
            focused
            style={{ marginBottom: "20px" }}
            value={nameModalOpen}
            onChange={(e) => setNameModalOpen(e.target.value)}
            ref={firstInputRef}
          />
          <Typography variant="h6" align="left">
            Email
          </Typography>
          <TextField
            placeholder="Email Address"
            fullWidth
            focused
            value={emailModalOpen}
            onChange={(e) => setEmailModalOpen(e.target.value)}
          />
          <Typography
            variant="h6"
            align="center"
            mt={0.5}
            mb={4}
            style={{ textDecoration: "underline", cursor: "pointer" }}
            onClick={handleUserAlternativeEmail}
          >
            Use alternative email
          </Typography>
          <Button
            variant="contained"
            style={{
              fontWeight: "bold",
            }}
            fullWidth
            onClick={handleSendEmail}
          >
            {updateAlternativeEmail.isPending ? "Loading" : "Send"}
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  padding: "50px",
};
